import { useEffect, lazy, Suspense } from 'react';
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from 'react-router-dom';
import { ComingSoon, LoadingScreen } from '~/components';
import { accountThunks } from '~/slices';
import { useDispatch, useSelector } from '~/hooks';
import { webEndpoints } from '~/endpoints';
import { ClaimYourToken } from './Main/ClaimYourToken/ClaimYourToken';

const Main = lazy(() =>
  import('./Main/Main').then((module) => ({ default: module.Main })),
);
const Chat = lazy(() =>
  import('./Main/Chat/Chat').then((module) => ({ default: module.Chat })),
);
const Servers = lazy(() =>
  import('~/pages/Main/Computers/Computers').then((module) => ({
    default: module.Computers,
  })),
);
const Login = lazy(() =>
  import('~/pages/Login/Login').then((module) => ({ default: module.Login })),
);

const router = createBrowserRouter([
  {
    path: webEndpoints.auth.path,
    element: (
      <Suspense fallback={<LoadingScreen />}>
        <Login />
      </Suspense>
    ),
  },
  {
    path: webEndpoints.index.path,
    element: (
      <Suspense fallback={<LoadingScreen />}>
        <Main />
      </Suspense>
    ),
    children: [
      {
        path: webEndpoints.index.path,
        element: <Navigate to={webEndpoints.chatById.to('new')} />,
      },
      {
        path: webEndpoints.chatById.path,
        element: (
          <Suspense fallback={<LoadingScreen />}>
            <Chat />
          </Suspense>
        ),
      },
      {
        path: webEndpoints.computers.path,
        element: (
          <Suspense fallback={<LoadingScreen />}>
            <Servers />
          </Suspense>
        ),
      },
      {
        path: webEndpoints.addInternalServer.path,
        element: <ComingSoon />,
        // element: <AddInternalServer />,
      },
      {
        path: webEndpoints.claimYourToken.path,
        // element: <ComingSoon />,
        element: <ClaimYourToken />,
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to={webEndpoints.chatById.to('new')} replace />,
  },
]);

export const Router = () => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.account);

  useEffect(() => {
    dispatch(accountThunks.refresh());
  }, []);

  if (loading) {
    return <LoadingScreen />;
  }

  return <RouterProvider router={router} />;
};
